import React from 'react';
import { AttachmentsColumnsProps } from '../../../../../../core/types/coreTypes';
import { useAppSelector } from '../../../../../../store/hooks';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import usePermission from '../../../../../../permissions-handling/permissionHook';
import { setSupplierAttachmentsFilters } from '../../../../../../store/slices/supplierSlice';
import { supplierAttachmentFiltersSelector } from '../../../../../../store/selectors/supplierSelector';
import AttachmentColumns from '../../../../../../common/components/attachments-table/AttachmentColumns';
import { useCoreAttachmentsColumns } from '../../../../../../core/hooks/useCoreAttachmentsColumns';

const SupplierAttachmentsColumns: React.FC<AttachmentsColumnsProps> = ({
  isAll,
  checkAll,
  totalElements,
  indeterminate,
}) => {
  const allowedManage = usePermission(PermissionEnum.SupplierEditFields);
  const attachmentsFilters = useAppSelector(supplierAttachmentFiltersSelector);

  const {
    searchVl,
    pickerValue,
    setPickerValue,
    sortHandle,
    onChangeSearchHandle,
    searchPressHandle,
    pickerHandle,
  } = useCoreAttachmentsColumns(attachmentsFilters, setSupplierAttachmentsFilters);

  return (
    <AttachmentColumns
      allowedManage={!!allowedManage}
      isAll={isAll}
      indeterminate={indeterminate}
      checkAll={checkAll}
      totalElements={totalElements}
      sortHandle={sortHandle}
      onChangeSearchHandle={onChangeSearchHandle}
      searchPressHandle={searchPressHandle}
      searchVl={searchVl}
      tableFilters={attachmentsFilters}
      pickerValue={pickerValue}
      setPickerValue={setPickerValue}
      pickerHandle={pickerHandle}
    />
  );
};

export default SupplierAttachmentsColumns;
